<template>
  <div>
    <div class="top" :style="{ alignItems: isCollapsed ? 'center' : 'flex-start' }">
      <Icon name="info-tianchong" class="tianchong" :style="{ marginTop: isCollapsed ? '' : '4px' }" />
      <div class="content">
        <div class="title">
          <div>
            <Icon
              :name="CURRENCY_MAPPER[amazonCountryCode].icon" class="icon"
            />
            {{
              $t('seller.brandsPage.accPolicyHeading', {
                host: CURRENCY_MAPPER[amazonCountryCode].host,
              })
            }}
          </div>
          <div class="collapse" :style="{margin: isCollapsed ? '0' : '16px 0'}" @click="isCollapsed = !isCollapsed" v-if="isCollapsed">
            <span class="collapse-style">
              {{ isCollapsed ? $t('seller.brandsPage.expand') : $t('seller.brandsPage.collapse') }}
            </span>
            <Icon name="jiantou-you-shuang-cu" class="jiantou" :class="{ 'rotate': !isCollapsed }" />
          </div>
        </div>
        <transition name="fade-slide">
          <div v-if="!isCollapsed">
            <p class="content">
              {{ $t('seller.brandsPage.accPolicyIntro') }}
            </p>
            <div class="bottom-content">
              <div class="item">
                <div class="item-top">
                  <div class="circle">
                    <div></div>
                  </div>
                  <div class="text">
                    {{ $t('seller.brandsPage.accPolicyCase1Title') }}
                  </div>
                </div>

                <div class="text-bottom">
                  {{ $t('seller.brandsPage.accPolicyCase1Body') }}
                </div>
              </div>

            </div>
            <div class="bottom-content">
              <div class="item">
                <div class="item-top">
                  <div class="circle">
                    <div></div>
                  </div>
                  <div class="text">
                    {{ $t('seller.brandsPage.accPolicyCase2Title') }}
                  </div>
                </div>

                <div class="text-bottom">
                  {{ $t('seller.brandsPage.accPolicyCase2Body') }}
                </div>
              </div>

            </div>
            <div class="bottom-btn">
              <div class="btn-style" v-if="isAcc" @click="handleCheckAuthorization">
                <Icon name="tiaozhuan" class="tiaozhuan" />
                <span class="text-style">{{ $t('seller.brandsPage.checkAccAuthorization') }}</span>
              </div>
              <div v-else>
                
              </div>
              <div class="collapse" @click="isCollapsed = !isCollapsed">
                <span class="collapse-style">
                  {{ isCollapsed ? $t('seller.brandsPage.expand') : $t('seller.brandsPage.collapse') }}
                </span>
                <Icon name="jiantou-you-shuang-cu" class="jiantou" :class="{ 'rotate': !isCollapsed }" />

              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div class="select-content">
      <div class="select-content-item">
        <div class="select-content-item-title">
          {{ $t('seller.brandsPage.selectedBrand') }}
        </div>
        <div class="select-content-item-content">
          <div class="select-content-item-content-item">
            <LogoImage :logoUrl="publisherDetail.publicImage" :brandName="publisherDetail.name" :width="28"
              :height="28" :fontSize="6" :borderRadius="4" />
            <div>
              {{ publisherDetail.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="select-content-item">
        <div class="select-content-item-title">
          {{
            $t('seller.brandsPage.selectedPublisherWithCount', {
              count: selectedPublisher.length,
            })
          }}
        </div>
        <div class="select-content-item-content">
          <!-- Display items that fit in the container -->
          <div class="select-content-item-content-item" v-for="values in visibleBrands" 
          :key="values.brandId">
            <LogoImage :logoUrl="values.publicImage" :brandName="values.creatorName" :width="28" :height="28"
              :fontSize="6" :borderRadius="4" />
            <div>
              {{ values.creatorName }}
            </div>
          </div>
          <!-- Display +X indicator if there are hidden items -->
          <div v-if="hiddenCount > 0" class="select-content-item-content-item">
            +{{ hiddenCount }}...
          </div>
        </div>
      </div>
    </div>
    <div class="commissions">
      <div class="commissions-item-title">
        {{ $t('seller.brandsPage.setUpCommissionsAndPeriod') }}
      </div>
      <div class="content">
        <div class="commission">
          <div class="commission-input">
            <span>{{ $t('seller.brandsPage.publisherCommission') }}</span>
            <artmisads-input-number :placeholder="$t('seller.common.pleaseEnter')" :min="0" :max="100" suffix="%" :step="0.5"
              size="large" @blur="commissionBlur" v-model:value="commission" @change="handleChangeCommission($event)" />

          </div>
          <span>+</span>
          <div class="fees" ref="fees">
            <span>{{ $t('seller.brandsPage.artemisAdsFees') }}
              <a-tooltip :getPopupContainer="() => $refs.fees">
                  <template #title>{{ $t('seller.brandsPage.publisherCommissionTooltip') }}</template>
                  <Icon name="wenhao-tianchong" class="question-icon" />
                </a-tooltip>
            </span>
            <artmisads-button disabled>
              <!-- {{ fees.toFixed(1) }}% -->
              3.0%
            </artmisads-button>
          </div>
          <span>=</span>
          <div class="total">
            <span>{{ $t('seller.brandsPage.totalLabel') }}</span>
            <artmisads-button disabled>
              <span>{{
                commission
                  ? parseFloat(3 + Number(commission)).toFixed(1)
                  : 3.0
              }}</span>
              <span>%</span>
            </artmisads-button>
          </div>
        </div>
        <div class="collaboration-section" ref="setCommissionRef">
          <div class="section-title">{{ $t('seller.brandsPage.collaborationPeriod') }}</div>
          <div class="date-row">
            <div class="date-group">
              <div class="date-label">{{ $t('seller.brandsPage.startDate') }}</div>
              <a-date-picker v-model:value="formData.startDate" :placeholder="$t('seller.common.selectDate')" format="YYYY-MM-DD"
                class="date-picker" :disabled-date="disabledStartDate" @change="handleStartDateChange"
                :getPopupContainer="() => $refs.setCommissionRef" />
            </div>
            <div class="date-group">
              <div class="date-label">{{ $t('seller.brandsPage.endDate') }}</div>
              <a-date-picker :showToday="false" :disabled="isAutoRenew" :allowClear="true" close-on-select v-model:value="formData.endDate"
                :placeholder="$t('seller.common.selectDate')" format="YYYY-MM-DD" class="date-picker" :disabled-date="disabledEndDate"
                :allow-clear="false" @change="handleEndDateChange" :getPopupContainer="() => $refs.setCommissionRef" />
            </div>

          </div>
        </div>
        <div class="auto-renew-section">
          <a-radio v-model:checked="isAutoRenew" @change="handleAutoRenewChange"
            @click="handleRadioClick">{{ $t('seller.brandsPage.continuous') }}</a-radio>
        </div>
      </div>
    </div>
    <div class="table">
      <div class="table-title">
          {{
            $t('seller.brandsPage.asinCommissionAccTitle', {
              country: CURRENCY_MAPPER[amazonCountryCode].name,
            })
          }}
          <a-popover>
    <template #content>
      <div class="top-popover" >
     
      <div class="content">
        <div class="title">
        <div>
          <Icon
            :name="CURRENCY_MAPPER[amazonCountryCode].icon" class="icon"
          ></Icon>
          {{
            $t('seller.brandsPage.accPolicyHeading', {
              host: CURRENCY_MAPPER[amazonCountryCode].host,
            })
          }}
        </div>
      
        </div>
       
          <p class="content">
            {{ $t('seller.brandsPage.accPolicyIntro') }}
          </p>
          <div class="bottom-content">
            <div class="item">
              <div class="item-top">
                <div class="circle">
                  <div></div>
                </div>
                <div class="text">
                  {{ $t('seller.brandsPage.accPolicyCase1Title') }}
                </div>
              </div>

              <div class="text-bottom">
                {{ $t('seller.brandsPage.accPolicyCase1Body') }}
              </div>
            </div>

          </div>
          <div class="bottom-content">
            <div class="item">
              <div class="item-top">
                <div class="circle">
                  <div></div>
                </div>
                <div class="text">
                  {{ $t('seller.brandsPage.accPolicyCase2Title') }}
                </div>
                </div>

                <div class="text-bottom">
                  {{ $t('seller.brandsPage.accPolicyCase2Body') }}
                </div>
              </div>
          </div>
      </div>
    </div>
    </template>
    <Icon name="wenhao-tianchong" class="wenhaotianchong"  />
  </a-popover>
        

      </div>
      <div class="table-content">
        <div class="table-head">
          <a-space>
            <ButtonGroups :pagination="pageSizeOptions" :tableData="dataSource" @pageChange="onPageChange" />
          </a-space>
          <a-input-search style="width: 256px;" v-model:value="queryParams.keywords" :placeholder="$t('seller.common.searchPlaceholder')" allow-clear @search="onSearch"
            @enter="onSearch">
          </a-input-search>
        </div>
        <artmisads-table
           
            v-model:pagination="pageSizeOptions"
            :columns="columns"
            :data-source="dataSource"
            :change="onTableChange"
            :loading="loading"
          >
         <template #bodyCell="{ column, text, record }">
          <template v-if="column.dataIndex === 'commission'">
                {{ record.commission=='N/A'?'N/A':record.commission+'%' }}
              </template>
               <template v-if="column.dataIndex === 'commissionPercentage'">
                {{ record.commissionPercentage?record.commissionPercentage+'%':'--' }}
              </template>
              <template v-if="column.dataIndex === 'accPeriod'">
                {{ moment(record.startDateTimeInEpochMills).tz(timeZone).format('YYYY-MM-DD')  }}~
                {{ moment(record.endDateTimeInEpochMills).tz(timeZone).format('YYYY-MM-DD') }}
              </template>
         </template>
        </artmisads-table>
      </div>
    </div>
     <div class="bottomFix">
      
      <div class="bottomFixContent">
        {{ $t('seller.brandsPage.settingUpCountryLead') }}
        <Icon :name="CURRENCY_MAPPER[amazonCountryCode].icon" class="icon"></Icon>
        {{
          $t('seller.brandsPage.settingUpCountryRest', {
            host: CURRENCY_MAPPER[amazonCountryCode].host,
          })
        }}
      </div>
      <div class="bottomFixButton">
        <artmisads-button type="default" @click="goBack">
          {{ $t('seller.brandsPage.back') }}
        </artmisads-button>
        <artmisads-button type="primary" @click="submit">
          {{ $t('seller.brandsPage.submit') }}
        </artmisads-button>
      </div>
    </div>
  </div>
</template>
<script setup>
import i18n from '~/i18n'

import { onMounted, ref, watch, reactive, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import Icon from '@/components/Icon.vue'
import LogoImage from '@/components/LogoImage.vue'
import { CURRENCY_MAPPER,COUNTRY_TIME_TZ } from '@/contants/common'
import moment from 'moment'
import ButtonGroups from '@/components/buttonGroups.vue'
import { publishersApi } from '@/server'
import { message } from 'ant-design-vue'
import { useSystemStore } from '@/storeData/system'
const systemStore = useSystemStore()
const isAcc = computed(() => systemStore.isAcc)
const dataSource=ref([])
const isAutoRenew = ref(false)
const amazonCountryCode = ref('')
const isCollapsed = ref(false)
const store = useUserInfoStore()
import { useUserInfoStore } from '@/storeData/index'
const userInfo = store.userInfo
const timeZone = COUNTRY_TIME_TZ[userInfo.countryCode]
const publisherDetail = ref({})
const props = defineProps(['selectedPublisher','selectedRowKeysId'])
const emit = defineEmits(['goBack','goNext'])
const visibleBrands = ref([]) // Brands that are visible
const hiddenCount = ref(0) // Count of hidden brands
const formData = reactive({
  currentCommissionRate: '',
  startDate: null,
  endDate: null,
  brandName: '',
  brandId: '',
  publisherId: '',
})
const pageSizeOptions = ref({
  size: 10,
  page: 1,
  current: 1,
  total: 30,
})
const queryParams=ref({
  keywords: '',
})
const loading=ref(false)
const { t: tCol, locale: localeCol } = useI18n()
const columns = computed(() => {
  localeCol.value
  return [
    {
      title: tCol('seller.brandsPage.colAsin'),
      dataIndex: 'asin',
      key: 'asin',
    },
    {
      title: tCol('seller.brandsPage.colProductName'),
      dataIndex: 'productName',
      key: 'productName',
    },
    {
      title: tCol('seller.brandsPage.colBrandName'),
      dataIndex: 'brandName',
      key: 'brandName',
    },
    {
      title: tCol('seller.brandsPage.colAccCommission'),
      dataIndex: 'commissionPercentage',
      key: 'commissionPercentage',
    },
    {
      title: tCol('seller.brandsPage.colAccPeriod'),
      dataIndex: 'accPeriod',
      key: 'accPeriod',
    },
    {
      title: tCol('seller.brandsPage.colAdjustedAssociateCommission'),
      dataIndex: 'commission',
      key: 'commission',
    },
  ]
})
const onPageChange = (page, pageSize) => {
  pageSizeOptions.value.page = page
  pageSizeOptions.value.current = page
  getList()
}
const onTableChange = ({ current, pageSize }) => {
  pageSizeOptions.value.page = current
  pageSizeOptions.value.current = current
  pageSizeOptions.value.size = pageSize
  pageSizeOptions.value.pageSize = pageSize
  getList()
}
// Calculate visible items to fill the container completely
const calculateVisibleItems = () => {
  console.log('calculateVisibleItems called')
  console.log('props.selectedBrands:', props.selectedPublisher.length)
  
  // Based on visual design: only show 3 rows of brands
  const rowsAvailable = 3
  const itemsPerRow = 5

  // Total visible items that can fit without overflow
  const maxVisibleItems = rowsAvailable * itemsPerRow
  console.log('maxVisibleItems:', maxVisibleItems)

  // Show only the items that fit within the container
  visibleBrands.value = props.selectedPublisher.slice(0, maxVisibleItems)
  console.log('visibleBrands.value:', visibleBrands.value.length)

  // Calculate how many items are hidden
  hiddenCount.value = Math.max(0, props.selectedPublisher.length - maxVisibleItems)
  console.log('hiddenCount.value:', hiddenCount.value)
}

// Watch for changes in selectedBrands
watch(() => props.selectedPublisher, () => {
  calculateVisibleItems()
}, { deep: true, immediate: true }) // Run immediately on component mount

watch(() => userInfo.countryCode, () => {
  amazonCountryCode.value = userInfo.countryCode
}, { immediate: true })
const commission = ref('')
function commissionBlur (e) {
  const newValue = e.target.value
    .replace(/[^0-9.]/g, '')
    .split('.')
    .map((v, i) => {
      v = v ? parseInt(v) : null

      if (i && v) {
        v = 5
      }

      return v
    })
    .join('.')
  let data = Number(newValue)
  data = data > 99 ? 99 : data
  // 将替换后的字符串转换为数字并赋值给 commission
  commission.value = data
  dataSource.value.forEach(item => {
    if(commission.value>Number(item.commissionPercentage)){
      item.commission =commission.value - Number(item.commissionPercentage)
    }else{
      item.commission = 0
    }
  })
}
const handleChangeCommission = (e) => {
  commission.value = e
  // dataSource.value.forEach(item => {
  //   if(commission.value>Number(item.accCommission.replace("%", ""))){
  //     item.commission =commission.value - Number(item.accCommission.replace("%", ""))
  //   }else{
  //     item.commission = 0
  //   }
  // })
}
const disabledStartDate = (current) => {
  // Start date should not be before today and should not be a weekend
  return current && current.isBefore(moment(), 'day')
}
const handleStartDateChange = (date) => {
  if (date) {
    formData.startDate = moment(date)

    // If end date exists and is before start date, clear end date
    if (formData.endDate && moment(formData.endDate).isBefore(moment(date), 'month')) {
      formData.endDate = null
    }
  }
}
const handleEndDateChange = (date) => {
  if (date) {
    const selectedEndDate = moment(date)

    // If end date is before start date, clear end date
    if (formData.startDate && selectedEndDate.isBefore(moment(formData.startDate), 'month')) {
      formData.endDate = null
      return
    }

    formData.endDate = selectedEndDate
  }
}
const disabledEndDate = (current) => {
  // End date should not be before start date, should not be before today, and should not be a weekend
  return current && ((formData.startDate && current.isBefore(formData.startDate)) || current.isBefore(moment()) || current.day() === 0 || current.day() === 6)
}
const handleAutoRenewChange = (e) => {

  if (isAutoRenew.value) {
    formData.endDate = moment('2099-12-31', 'YYYY-MM-DD')
  } else {
    formData.endDate = initEndDate.value
  }
}
const handleRadioClick = (e) => {
  // 如果当前已经是选中状态，则取消选中
  if (isAutoRenew.value) {
    e.preventDefault()
    isAutoRenew.value = false
    // 手动触发 change 事件
    handleAutoRenewChange({ target: { checked: false } })
  } else {
    // 如果当前未选中，则选中
    e.preventDefault()
    isAutoRenew.value = true
    // 手动触发 change 事件
    handleAutoRenewChange({ target: { checked: true } })
  }
}
const onSearch = (value) => {
  queryParams.value.keywords = value
  pageSizeOptions.value.page = 1
  pageSizeOptions.value.size = 10
  getTableList()
}
const getTableList = () => {
  publishersApi.getAcceptedAsins({
    publisherIds:props.selectedRowKeysId,
    brandIds: [publisherDetail.value.id],
    // publisherIds: [110],
    // brandIds: [3216],
    page: pageSizeOptions.value.page,
    size: pageSizeOptions.value.size,
    keywords: queryParams.value.keywords,
  }).then(res => {
    if(res.success){
    dataSource.value = res.data.data || []
    dataSource.value.forEach(item => {
      if (
          commission.value
        ) {
          if (commission.value > Number(item.commissionPercentage)) {
            item.commission = commission.value - Number(item.commissionPercentage)
          } else {
            item.commission = 0
          }
        } else {
          item.commission = 'N/A'
         }
    })
    pageSizeOptions.value.total = res.data.total || 0
    }
  })
}
const goBack=async()=>{
  emit('goBack')
}
const submit = async() => {
  if (!formData.startDate || !formData.endDate) {
    message.error(i18n.global.t('seller.brandsPage.errSelectStartEndDate'))
    return
  }
  if(!commission.value){
    message.error(i18n.global.t('seller.brandsPage.errInputCommission'))
    return
  }
 const commissionList= props.selectedRowKeysId.map(item=>{
     return {
          publisherId:item ,
          brandId: publisherDetail.value.id,
          commissionRate: commission.value,
          startDate:formData.startDate.format('YYYY-MM-DD'),
          endDate: formData.endDate.format('YYYY-MM-DD'),
          platformFeeRate:3
        }
  })
     const res=await publishersApi.updatePublisherCommissionBatch({commissionList:commissionList})
      if (res.success) {
      message.success(i18n.global.t('seller.msg.partnershipSaved'))
      emit('goNext')
    } else {
      message.error(res.error || i18n.global.t('seller.msg.updateFailed'))
    }
}
const handleCheckAuthorization=()=>{
  window.open(`/seller/creatorConnections/authorization`)
}
onMounted(() => {
  publisherDetail.value = JSON.parse(sessionStorage.getItem('brandDetail'))
  console.log(publisherDetail.value, ' publisherDetail.value ',props.selectedRowKeysId)
  calculateVisibleItems()
  getTableList()
})
</script>
<style scoped lang="less">
  .wenhaotianchong{
    color: rgba(15, 6, 41, 0.3);
  }
.collapse {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 16px 0;
  cursor: pointer;

  .jiantou {

    color: rgba(15, 6, 41, 0.9);
  }

  .collapse-style {
    color: rgba(15, 6, 41, 0.9);
    font-family: Sora;
    font-weight: 400;
    font-size: 14px;


  }
}
.top-popover{
  .content {
    flex: 1;

    .title {
      font-family: Sora;
      font-weight: 600;
      font-style: SemiBold;
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .content {
      font-family: Sora;
      font-weight: 400;
      font-style: Regular;
      font-size: 14px;
      margin-top: 10px;

      .popover-line {
        margin: 0 0 6px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .bottom-content {
      margin-top: 10px;

      .item {
        background-color: rgba(248, 247, 252, 1);
        border-radius: 8px;
        padding: 12px 16px;

        .item-top {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .circle {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 14px;
          height: 14px;

          border-radius: 50%;
          background: rgba(108, 61, 242, 0.2);

          >div {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: rgba(108, 61, 242, 1);
          }
        }

        .text {
          font-family: Sora;
          font-weight: 600;
          font-style: SemiBold;
          font-size: 13px;
          color: rgba(108, 61, 242, 1);

        }

        .text-bottom {
          font-family: Sora;
          font-weight: 400;
          font-style: Regular;
          font-size: 13px;
          color: rgba(15, 6, 41, 1);
        }
      }
    }
  }
}
.top {
  position: relative;
  display: flex;
  background-color: rgba(255, 245, 229, 1);
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  margin-top: 16px;
  box-shadow: 0px 1px 0px 0px rgba(15, 6, 41, 0.05);
  border: 1px solid rgba(255, 150, 25, 1);
  border-radius: 8px;
  padding: 16px;

  .tianchong {
    color: rgba(245, 155, 0, 1);

    margin-right: 16px;
    width: 16px;
    height: 16px;
  }

  .content {
    flex: 1;

    .title {
      font-family: Sora;
      font-weight: 600;
      font-style: SemiBold;
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .content {
      font-family: Sora;
      font-weight: 400;
      font-style: Regular;
      font-size: 14px;
      margin-top: 10px;

    }

    .bottom-content {
      margin-top: 10px;

      .item {
        background-color: rgba(255, 255, 255, 0.8);
        border-radius: 8px;
        padding: 12px 16px;

        .item-top {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .circle {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 14px;
          height: 14px;

          border-radius: 50%;
          background: rgba(245, 155, 0, 0.2);

          >div {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: rgba(245, 155, 0, 1);
          }
        }

        .text {
          font-family: Sora;
          font-weight: 600;
          font-style: SemiBold;
          font-size: 13px;
          color: rgba(230, 130, 0, 1);

        }

        .text-bottom {
          font-family: Sora;
          font-weight: 400;
          font-style: Regular;
          font-size: 13px;
          color: rgba(15, 6, 41, 1);
        }
      }
    }
  }

  .bottom-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .btn-style {
      cursor: pointer;
      display: flex;
      align-items: center;
      background-color: rgba(245, 155, 0, 1);
      border-radius: 90px;
      gap: 10px;
      padding: 6px 16px;

      .tiaozhuan {
        color: #fff;
      }

      .jiantou {}

      .text-style {
        color: #fff;
      }
    }

  }
}

.select-content {
  display: flex;
  gap: 16px;
  margin: 16px 0;

  .select-content-item {
      flex: 1;
      background-color: #fff;
      border-radius: 8px;
      padding: 16px;
      height: 262px;
      overflow: hidden;
      position: relative;
      box-sizing: border-box;

    .select-content-item-title {
      font-family: Sora;
      font-weight: 600;
      font-size: 20px;
      color: rgba(15, 6, 41, 1);
      padding-bottom: 16px;
      border-bottom: 1px solid rgba(232, 229, 237, 1);
    }

    .select-content-item-content {
      display: flex;
      gap: 10px;
      flex-wrap: wrap;
      margin: 16px 0;
      max-height: calc(100% - 70px);
      /* Leave space for title and padding */
      overflow: hidden;
      height: calc(100% - 70px);
      /* Ensure fixed height */
      box-sizing: border-box;
      /* Include padding in height calculation */

      .select-content-item-content-item {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 6px 8px;
        background-color: rgba(241, 240, 245, 1);
        border-radius: 8px;
        /* Ensure consistent height for all items */
        height: 32px;
        box-sizing: border-box;
      }

      .select-content-item-content-more {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        padding: 6px 8px;
        background-color: rgba(241, 240, 245, 1);
        border-radius: 8px;
        font-family: Sora;
        font-weight: 500;
        font-size: 12px;
        color: rgba(15, 6, 41, 0.7);
      }
    }
  }
}

.commissions {
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  padding: 16px;

  .commissions-item-title {
    font-family: Sora;
    font-weight: 600;
    font-size: 20px;
    color: rgba(15, 6, 41, 1);
    padding-bottom: 16px;
    border-bottom: 1px solid rgba(232, 229, 237, 1);
  }

  .content {
    display: flex;
    flex-direction: column;
    margin-top: 8px;
    margin-top: 16px;
    // margin-bottom: 20px;

    .commission {
      display: flex;

      >span {
        align-self: center;
        margin: 20px 10px 0 10px;
        font-family: Sora, sans-serif;
        font-weight: 500;
        color: #0f0629;
      }

      .fees,
      .total,
      .commission-input {
        display: flex;
        flex-direction: column;

        >span {
          margin-bottom: 6px;
          font-weight: 500;
          color: var(--dark-2);
          line-height: 19px;
        }
      }

      .commission-input {
        position: relative;

        .defalut-text {
          position: absolute;
          font-family: Sora, sans-serif;
          color: var(--dark-4);
          line-height: 20px;
          left: 15px;
          top: 34px;
          margin: 0;
        }

        .haifenhao {
          position: absolute;
          font-weight: 500;
          font-size: var(--font-size-large);
          color: var(--dark-1);
          right: 30px;
          top: 34px;
          margin: 0;
        }

        :deep(.ant-input-number) {
          width: 200px;

          .ant-input-number-handler-wrap {
            opacity: 1;
          }
        }
      }

      .total {
        >button {
          width: 96px;
          display: flex;
          justify-content: space-between;

          >span {
            align-self: center;
          }
        }
      }

      .fees {
        >button {
          width: 144px;
        }

        .question-icon {
          margin-left: 3px;
          color: var(--yellow-4);
        }
      }

      .fees,
      .total {
        >button {
          padding-left: 12px;
          text-align: left;
          border-radius: 8px;
          font-weight: 500;
          font-size: var(--font-size-large);
          color: var(--dark-1);
        }
      }
    }

    .collaboration-section {
      margin-bottom: 26px;
      margin-top: 26px;

      .section-title {
        color: #0f0629;
        font-family: "Sora";
        font-size: 16px;
        font-style: normal;
        font-weight: 600;

        letter-spacing: 0.4px;
        opacity: 0.9;
        margin-bottom: 8px;
      }

      .date-row {
        display: flex;
        gap: 24px;

        .date-group {
          width: 324px;

          .date-label {
            font-size: 14px;
            color: rgba(15, 6, 41, 0.8);
            margin-bottom: 8px;
            font-weight: 500;
          }

          .date-picker {
            width: 100%;
          }
        }
      }
    }
  }
}

.table {
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  padding: 16px;
  margin: 16px 0;

  .table-title {
    display: flex;
    align-items: center;
    font-family: Sora;
    font-weight: 600;
    font-size: 20px;
    color: rgba(15, 6, 41, 1);
    padding-bottom: 16px;
    border-bottom: 1px solid rgba(232, 229, 237, 1);
  }
  .table-head{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 16px 0;
  }
}
.bottomFix {
  position: sticky;
  left: 0;
  bottom: 0;
  right: 0;
  height: 64px;
  border: 1px solid #E8E5ED;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
z-index: 999;

  .bottomFixContent {
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  display: flex;
  align-items: center;

  .icon {
    margin: 2px 2px 0;
    font-size: 16px;
  }
}
.bottomFixButton{
  display: flex;
  align-items: center;
  gap: 20px;
}
}

/* 动画效果 */
.jiantou {
  transition: transform 0.3s ease;
  transform: rotate(90deg);
}

.jiantou.rotate {
  transform: rotate(270deg);
}

/* 内容展开/折叠动画 */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
  max-height: 500px;
  overflow: hidden;
  opacity: 1;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  max-height: 0;
  overflow: hidden;
}
</style>
